<div *ngIf="isPageReady" id="printable-invoice" class="h-full flex">
  <div class="no-print p-2 grow flex flex-col border-2 shadow-lg" style="max-width: 8.5in; min-width: 8.5in">
    <div *ngIf="!invoiceHeader" #printableArea class="screen-p-20">
      <h2>Invoice {{ invoiceId }} not found; it may have been undone.</h2>
    </div>
    <div *ngIf="invoiceHeader" #printableArea class="screen-p-20 grow" style="overflow: auto">
      <ng-container *ngIf="!isAllInvoices">
        <app-printable-invoice-content [invoiceHeader]="invoiceHeader"></app-printable-invoice-content>
      </ng-container>

      <ng-container *ngIf="isAllInvoices">
        <ng-container *ngFor="let invoice of invoiceHeaders">
          <div class="break"></div>
          <app-printable-invoice-content [invoiceHeader]="invoice"></app-printable-invoice-content>
        </ng-container>
      </ng-container>
    </div>

    <div uni-flex-row class="accent no-print mt-4">
      <div>
        <span class="ml-4">{{ email?.status }} {{ email?.statusTs | date : "long" }}</span>
      </div>

      <div>
        <button pButton type="button" class="p-button-raised" [disabled]="!invoiceHeader" icon="pi pi-print" (click)="print()">
          <span>Print</span>
        </button>
        <button pButton type="button" class="p-button-raised ml-2" [disabled]="!invoiceHeader" icon="pi pi-envelope" (click)="emailInvoice()">
          <span>Email</span>
        </button>
        <button pButton type="button" class="p-button-raised ml-2" [disabled]="!invoiceHeader" (click)="showInvoiceDialog()">
          <span>Show Invoice</span>
        </button>
        <button pButton type="button" class="p-button-raised ml-2" icon="pi pi-arrow-left" (click)="goBack()">
          <span>Go Back</span>
        </button>
      </div>
    </div>
  </div>
  <p-confirmDialog></p-confirmDialog>
  <!-- / CENTER -->
</div>